import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZapIcon from '@zapsa/zap-icons';

import whySquareboard from 'assets/images/why_squareboard.svg';

class WhySquareboardView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="container-title">{this.props.translations['why.whySquareboard']}</div>
        <div className="why-squareboard-grid-left">
          <img src={whySquareboard} alt="" className="u-img-hmax" />
        </div>
        <div className="why-squareboard-grid-right">
          <div className="box">
            <div className="squareboard-moto-title u-text-dark-grey" style={{}}>
              <ZapIcon icon="messages--lines" className="u-mr-2" />
              {this.props.translations['why.communicate']}
            </div>
            <div className="squareboard-moto-desc u-text-dark-grey">
              {this.props.translations['why.communicateDesc']}
            </div>
          </div>
          <div className="box">
            <div className="squareboard-moto-title u-text-dark-grey">
              <ZapIcon icon="userGroups--lines" className="u-mr-2" />
              {this.props.translations['why.unify']}
            </div>
            <div className="squareboard-moto-desc u-text-dark-grey">{this.props.translations['why.unifyDesc']}</div>
          </div>
          <div className="box">
            <div className="squareboard-moto-title u-text-dark-grey">
              <ZapIcon icon="check--lines" className="u-mr-2" />
              {this.props.translations['why.accomplish']}
            </div>
            <div className="squareboard-moto-desc u-text-dark-grey">
              {this.props.translations['why.accomplishDesc']}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WhySquareboardView;
